var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#515050",
    d: "M16.379 6.207C15.189 5.255 13.743 4.5 12 4.5a7.5 7.5 0 1 0 7.065 10.026c.185-.52.71-.87 1.25-.755l.978.208c.54.114.89.647.725 1.174C20.678 19.411 16.702 22.5 12 22.5 6.201 22.5 1.5 17.799 1.5 12S6.201 1.5 12 1.5c2.783 0 4.952 1.268 6.511 2.575l1.782-1.782A1 1 0 0 1 22 3v5.5a1 1 0 0 1-1 1h-5.5a1 1 0 0 1-.707-1.707z",
    opacity: 1,
    "data-original": "#1e1e1e",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a74c0999c5575d2a376a31f85ca52fa1.svg";
export { ForwardRef as ReactComponent };